import axios from 'axios';
import OAuthInterceptor from './OAuthInterceptor';
var axiosInstance = axios.create();
var ApiFetch = /** @class */ (function () {
    function ApiFetch(baseUrl, ClearLocalStorage) {
        this.baseUrl = baseUrl;
        this.ClearLocalStorage = ClearLocalStorage;
    }
    ApiFetch.prototype.fetch = function (method, url, params) {
        if (params === void 0) { params = {}; }
        var oauth = localStorage.getItem('oauth');
        if (null === oauth) {
            this.ClearLocalStorage();
            window.location.href = '/#/login';
            return Promise.reject('Oauth not found in localstorage');
        }
        var viewAs = localStorage.getItem('viewAs');
        if (null === viewAs) {
            this.ClearLocalStorage();
            window.location.href = '/#/login';
            return Promise.reject('ViewAs not found in localstorage');
        }
        var user = localStorage.getItem('user');
        if (null === user) {
            this.ClearLocalStorage();
            window.location.href = '/#/login';
            return Promise.reject('User not found in localstorage');
        }
        var userObject = JSON.parse(user);
        var environment = '/sandbox/';
        if (null === userObject) {
            environment = '/no-environment/';
        }
        else if (userObject.environment === 'PRODUCTION') {
            environment = '/';
        }
        var authObject = JSON.parse(oauth);
        params.signature = authObject === null || authObject === void 0 ? void 0 : authObject.clientSecret;
        axiosInstance.interceptors.response.use(undefined, OAuthInterceptor(this.baseUrl, axiosInstance, this.ClearLocalStorage));
        return axiosInstance.request({
            method: method,
            baseURL: this.baseUrl + environment + url,
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Bearer ".concat(authObject === null || authObject === void 0 ? void 0 : authObject.accessToken),
                'X-View-As': JSON.parse(viewAs).uuid,
                'X-Client-Group': null,
            },
            data: params,
        });
    };
    return ApiFetch;
}());
export default ApiFetch;
